export default __webpack_public_path__ + "images/00ca34caf1844f4935f2035dd18dfdaf.jpg";